const PATH = {
    main: '/',
    caseStudy1: 'case-study-1',
    caseStudy2: 'case-study-2',
    caseStudy3: 'case-study-3',
};

export default PATH;
